module.exports = __webpack_public_path__ + "static/media/trending_up.f36e8d03.svg";